import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import {DemoService} from '../../../demo.service';

import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { SystemLog } from './../../../shared/models/sysLog.model';

// :: @https://www.thecodehubs.com/sweet-alerts-in-angular/
// import Swal from 'sweetalert2';


@Component({
  selector: 'app-brand-global-company-key-widget',
  templateUrl: './brand-global-company-key-widget.component.html',
  styleUrls: ['./brand-global-company-key-widget.component.scss']
})
export class BrandGlobalCompanyKeyWidgetComponent implements OnInit {


  name = 'Angular';
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'full'; // side | abstract | full | checker | update_password

  job: Object;
  job_id;
  user_id;


  signupForm: FormGroup;
  passwordIsValid = false;

  registrationForm: FormGroup;
  fieldTextType: boolean;
  repeatFieldTextType: boolean;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  password_update_response: Object;

  @Input() log_data: SystemLog;
  key_update_response: Object;
  brand_id: any;




  constructor(private fb: FormBuilder, public gfunc: GlobalFunctionsService,
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    ) {
      // Set and Access login Session Variables

// disabled to work in public
      // this.gfunc.setLoginSessionVars(); // set in a global function file
            // this.sessionUserId = this.gfunc.currentUserVAR.user_id;
            // this.sessionUsername = this.gfunc.currentUserVAR.username;
            // this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

     // need to add this as routes does not work globally
     this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


          // this.toastr.setRootViewContainerRef(vcr);
    }

         // check for changes. to load data.
         ngOnChanges(changes) {
          if (changes.item_id) {
            // deal with asynchronous Observable result
            // this.user_id = changes.item_id.currentValue;
            this.brand_id = changes.item_id.currentValue;
            // this.getJob(this.job_id);
          }
        }


  ngOnInit() {

    this.signupForm = this.fb.group({
      password: ['', Validators.required],
      stay_logged_in: [false],
      user_id: [this.user_id],
      brand_id: [this.brand_id],
      updated_date: [this.gfunc.today],
      updated_by: [this.user_id]
    });

    // load a form by function: New dynamic forms
    // this.initRegForm();


  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }


  initRegForm() {
    this.registrationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      confirmpassword: ['', Validators.required], 
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleRepeatFieldTextType() {
    this.repeatFieldTextType = !this.repeatFieldTextType;
  }


  sweetAlert(){

  }

  // Functions
  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Run the job data queries.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

// update was here for onit but moved for onchange
updateBrandPasswordKeyHash(model) {
 
 
 
            this._demoService.updateBrandPasswordKeyHash(model).subscribe(
               data => {
                this.key_update_response = data;
                console.log(this.key_update_response);
                 // this.trace_candidate_update = data;
               this.toastr.success('Global Company Key Encrypted and Updated Successful.');
               console.log('model.stay_logged_in: ', model.stay_logged_in);
               // logout if not checked.


          // insert a log

            // this.log_data = {
            //   log_id: null,
            //   log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
            //   log_action: 'reset', // automated / updated / created / uploaded / link_created / sent / accessed
            //   created_by: this.gfunc.sessionUserId,
            //   created_date: this.gfunc.today,
            //   subject_id: null,
            //   job_id: null,
            //   job_reference_number: null,
            //   file_number: null,
            //   reference_number: null,
            //   subject_number: null,
            //   log_type_id: 24 , // see datatable system_log_types
            //   created_level: 4, // staff manager
            //   brand_type_id: this.gfunc.sessionBrandTypeId,
            //   subject_com_type_id: null,
            //   subject_template_doc_id: null,
            //   log_name: 'User Password Reset: ' + ' - ' + this.gfunc.sessionUserFullName + ' (' + this.gfunc.sessionUserName + ')',
            //   file_id: null,
            //   brand_id: this.gfunc.sessionBrandId,
            //   user_id: this.gfunc.sessionUserId
            // };

              // this.gfunc.createSystemLog(this.log_data);
              // this.gfunc.insertLog_UpdateUserPassword(this.log_data);
          
              //     if (model.stay_logged_in != true ) {
              //       // console.log('model.stay_logged_in: ', model.stay_logged_in);
              //       // console.log('form,.stay_logged_in: ', this.signupForm.get('stay_logged_in').value);
              //      alert('Success: password reset! You will now be directed to login.');
              //       this.gfunc.login();
              //     }

          // close the modal
          this.closeParentModel.emit();
               // Subject to reload the manager component parent.
              // BrandUserManagerComponent.returned.next(false);
                 return true;
               },
               error => {
                this.toastr.error('Error saving new password, not changed! Try Again.');
                 console.error('Error saving new password, not changed! Try Again.');
                return console.log(error);
               }
              // err => console.error(err),
              // () => console.log('done updates')
            );
  }



}
